import "../../css/master.css";
import "../../css/app.css";
import "../../css/custom.css";
import MainComponent from "./main_component";
import SideBar from "../../sidebar/sidebar"
import CheckUserInfoAgreement from "../../checkUserInfoAgreement";

function UserInfoCompelition() {

    return (
        <>
            <CheckUserInfoAgreement />
            <div className="header-utility">
                <div className="header-utility-inner">
                    <ul className="header-utility-list sub">
                    </ul>
                </div>
            </div>
            <main className="site-main">
                <section className="sct-primary">
                    <div className="ls-row str-column" id="ls-row-3-col-1-row-2">
                        <SideBar />
                        <MainComponent />
                    </div>
                </section>
            </main>
        </>
    );
}


export default UserInfoCompelition;